import { mockAuth } from './mockData/mockEndpoints/authMockEndpoint';
import { cardsMock } from './mockData/mockEndpoints/cardsMockEndpoint';
import { categoriesMock } from './mockData/mockEndpoints/categoriesMockEndpoint';
import { geoipMock } from './mockData/mockEndpoints/geoIPMockEndpoint';
import { buildsMock } from './mockData/mockEndpoints/buildsMockEndpoint';
import { attachmentsMock } from './mockData/mockEndpoints/attachmentsMockEndpoint';
import { bookmarksMock } from './mockData/mockEndpoints/bookmarksMockEndpoint';
import { categorySummaryMock } from './mockData/mockEndpoints/categorySummaryMockEndpoint';

export const HitchpinMockApi = {
  auth: mockAuth,
  agreements: {
    uploadSingle: (_id, agreement) => {
      const mockAgreement = {
        ...agreement,
        id: 1,
        agreement_type: agreement.agreement_type,
        local_identifier: agreement.local_identifier,
        transaction: agreement.transaction,
      };
      return Promise.resolve({
        status: 201,
        data: mockAgreement,
      });
    },
  },
  attachments: attachmentsMock,
  bookmarks: bookmarksMock,
  builds: buildsMock,
  cards: cardsMock,
  categories: categoriesMock,
  categorySummary: categorySummaryMock,
  chats: {
    notImplemented: () => console.log('chats not implemented'),
  },
  chatMessages: {
    notImplemented: () => console.log('chatMessages not implemented'),
  },
  chatUsers: {
    notImplemented: () => console.log('chatUsers not implemented'),
  },
  clientVersion: {
    postAppVersion: () => {
      console.log('clientVersion mock called');
      return Promise.resolve({
        status: 200,
        statusText: 'OK',
        body: {
          version: '1.0.0-mock',
        },
      });
    },
  },
  commerce: {
    notImplemented: () => console.log('commerce not implemented'),
  },
  contact: {
    notImplemented: () => console.log('contact not implemented'),
  },
  contestSubmissions: {
    notImplemented: () => console.log('contestSubmissions not implemented'),
  },
  couponFavorites: {
    notImplemented: () => console.log('couponFavorites not implemented'),
  },
  coupons: {
    notImplemented: () => console.log('coupons not implemented'),
  },
  device: {
    notImplemented: () => console.log('device not implemented'),
  },
  geoip: geoipMock,
  icons: {
    notImplemented: () => console.log('icons not implemented'),
  },
  invoices: {
    notImplemented: () => console.log('invoices not implemented'),
  },
  lands: {
    notImplemented: () => console.log('lands not implemented'),
  },
  myOfferings: {
    notImplemented: () => console.log('myOfferings not implemented'),
  },
  myWanteds: {
    notImplemented: () => console.log('myWanteds not implemented'),
  },
  notifications: {
    notImplemented: () => console.log('notifications not implemented'),
  },
  offeringImages: {
    notImplemented: () => console.log('offeringImages not implemented'),
  },
  offeringVideos: {
    notImplemented: () => console.log('offeringVideos not implemented'),
  },
  offerings: {
    notImplemented: () => console.log('offerings not implemented'),
  },
  offeringReviews: {
    notImplemented: () => console.log('offeringReviews not implemented'),
  },
  paymentMethods: {
    notImplemented: () => console.log('paymentMethods not implemented'),
  },
  profile: {
    notImplemented: () => console.log('profile not implemented'),
  },
  promoted: {
    notImplemented: () => console.log('promoted not implemented'),
  },
  purchases: {
    notImplemented: () => console.log('purchases not implemented'),
  },
  purchaseSchema: {
    notImplemented: () => console.log('purchaseSchema not implemented'),
  },
  purchaseTickets: {
    notImplemented: () => console.log('purchaseTickets not implemented'),
  },
  purchaseLands: {
    notImplemented: () => console.log('purchaseLands not implemented'),
  },
  questions: {
    notImplemented: () => console.log('questions not implemented'),
  },
  reviews: {
    notImplemented: () => console.log('reviews not implemented'),
  },
  reviewDimensions: {
    notImplemented: () => console.log('reviewDimensions not implemented'),
  },
  reviewStars: {
    notImplemented: () => console.log('reviewStars not implemented'),
  },
  sales: {
    notImplemented: () => console.log('sales not implemented'),
  },
  saleLands: {
    notImplemented: () => console.log('saleLands not implemented'),
  },
  saleSchema: {
    notImplemented: () => console.log('saleSchema not implemented'),
  },
  saleReviews: {
    notImplemented: () => console.log('saleReviews not implemented'),
  },
  saleTickets: {
    notImplemented: () => console.log('saleTickets not implemented'),
  },
  searchAlert: {
    notImplemented: () => console.log('searchAlert not implemented'),
  },
  storefronts: {
    notImplemented: () => console.log('storefronts not implemented'),
  },
  supplyProposals: {
    notImplemented: () => console.log('supplyProposals not implemented'),
  },
  userAddresses: {
    notImplemented: () => console.log('userAddresses not implemented'),
  },
  wallet: {
    notImplemented: () => console.log('wallet not implemented'),
  },
  waivers: {
    notImplemented: () => console.log('waivers not implemented'),
  },
  wanteds: {
    notImplemented: () => console.log('wanteds not implemented'),
  },
};
